import { SignalRService } from '~/core/services/signalRService';
import { useNotifications } from '~/composables/useNotifications';
import { useAuthStore } from '~/stores/auth';

export default defineNuxtPlugin(() => {
  // Chỉ chạy trên client
  if (process.server) return;

  // Khởi tạo notifications khi user đã đăng nhập
  const initializeNotifications = async () => {
    try {
      const { startListening, requestNotificationPermission } = useNotifications();
      const authStore = useAuthStore();
      
      // Kiểm tra xem user đã đăng nhập chưa
      if (authStore.isAuthenticated && authStore.token) {
        // Khởi động SignalR connection nếu chưa có
        SignalRService.startConnection(authStore.token);
        
        // Bắt đầu lắng nghe notifications
        startListening();
        
        // Yêu cầu quyền thông báo từ browser (tùy chọn)
        // await requestNotificationPermission();
        
        console.log('Toast notification system initialized');
      }
    } catch (error) {
      console.error('Failed to initialize notifications:', error);
    }
  };

  // Khởi tạo sau khi app đã sẵn sàng
  setTimeout(() => {
    const authStore = useAuthStore();
    
    // Khởi tạo ngay nếu đã đăng nhập
    if (authStore.isAuthenticated) {
      initializeNotifications();
    }

    // Theo dõi trạng thái đăng nhập để khởi tạo notifications
    watch(
      () => authStore.isAuthenticated,
      (isAuthenticated) => {
        if (isAuthenticated) {
          initializeNotifications();
        }
      },
      { immediate: false }
    );
  }, 100);
}); 